import React, { useState } from "react";
import { GrFormPrevious } from "react-icons/gr";
import GroupChatSearch from "../../GroupChatSideBar/GroupChatSearch/GroupChatSearch";
import SelectedChatAvatars from "../../GroupChatSideBar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/SelectedChatAvatars/SelectedChatAvatars";
import ChatListItem from "../../GroupChatSideBar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListItem/ChatListItem";
import ChatListFooter from "../../GroupChatSideBar/GroupChatList/GroupChatsSectionListItems/GroupChatSections/ChatListFooter/ChatListFooter";
import AllUserList from "../../../../Components/AllUserList/AllUserList";
import { FiSearch } from "react-icons/fi";
import InfiniteScroll from "../../../../Components/InfiniteScroll/InfiniteScroll";

export default function AddGroupMember({
  setActiveSection,
  setShowAddGroupMember,
  allUser,
  allUserCurrentPage,
  allUserTotalPages,
  handleAddGroupMember,
  isLoading,
  fetchAllUser,
}) {
  const [selectedChats, setSelectedChats] = useState([]);
  const [timeoutId, setTimeoutId] = useState(null);

  const handleSelectChat = (user) => {
    const alreadySelected = selectedChats.find((u) => u._id === user._id);
    if (alreadySelected) {
      setSelectedChats((prev) => prev.filter((u) => u._id !== user._id));
    } else {
      setSelectedChats((prev) => [...prev, user]);
    }
  };

  const handleRemoveSelected = (id) => {
    setSelectedChats((prev) => prev.filter((chat) => chat._id !== id));
  };

  const handleSearch = (e) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(() => {
        const searchQuery = e.target.value;
        fetchAllUser(1, searchQuery.trim());
      }, 500)
    );
  };

  return (
    <section className="h-screen flex flex-col">
      {/* Header */}
      <div className="sticky top-0 z-10 border-l border-[#EBEBEB] w-full min-h-[67px] py-2.5 bg-white flex items-center justify-between border-b text-black p-4">
        <div className="flex items-center gap-4">
          <GrFormPrevious
            onClick={() => {
              setActiveSection("contact");
              setShowAddGroupMember(false);
            }}
            className="cursor-pointer hover:text-[var(--primary-color)] h-8 w-8 p-1 border rounded-md"
          />
          <h1 className="text-lg font-semibold">Add Group Members</h1>
        </div>
      </div>

      {/* Body */}
      <div className="sticky  z-10 bg-white px-4 pt-4 ">
        <div className="relative w-full max-w-md">
          <input
            onKeyDown={(e) => handleSearch(e)}
            type="text"
            placeholder="Search Member"
            className="input bg-inherit h-12 rounded-lg border border-[#EBEBEB] input-bordered w-full pl-10 py-[12px] placeholder:text-black"
          />
          <FiSearch className="absolute left-3 top-8 transform -translate-y-1/2 text-black" />
        </div>
      </div>
      <div className="flex flex-col flex-1 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-200 px-4">
        {selectedChats.length > 0 && (
          <SelectedChatAvatars
            selectedChats={selectedChats}
            handleRemoveSelected={handleRemoveSelected}
          />
        )}
        {allUser?.length > 0 && (
          <InfiniteScroll
            dataLength={allUser.length}
            next={() => fetchAllUser(allUserCurrentPage + 1, "")}
            hasMore={allUserCurrentPage < allUserTotalPages}
            loader={<p className="text-center">Loading...</p>}
          >
            {allUser?.map((item) => (
              <AllUserList
                key={item._id}
                users={item}
                selected={selectedChats.some((u) => u._id === item._id)}
                handleSelectChat={handleSelectChat}
              />
            ))}
          </InfiniteScroll>
        )}
        {allUser.length <= 0 && (
          <div className="flex-grow flex items-center justify-center h-full">
            <p className="text-[#7104F8] font-semibold">Member Not Found</p>
          </div>
        )}
        {/* Footer */}
      </div>
      {selectedChats.length > 0 && (
        <div className="sticky bottom-0 bg-white z-20 p-4 ">
          <ChatListFooter
            onDone={() => {
              handleAddGroupMember(selectedChats);
            }}
            isLoading={isLoading}
          />
        </div>
      )}
    </section>
  );
}
